import React from 'react';
import { useTranslation } from 'react-i18next';
import './Tool.css'; 

function Tool() {
  const { t } = useTranslation();

  return (
   <div className="cases-page">
  <div className="text-container-cases">
    <h2 className="title-blue-cases">{t('exemplos')}</h2>
    
    <p className="intro-text-cases">
      {t('exemplos-sector')}
    </p>

    <div className="case-card">
      <h3 className="case-subtitle">{t('residuos')}</h3>
      <p>
        <strong>{t('goal-label')}:</strong> {t('residues-goal')}
      </p>
      <p className="actions-header">
        <strong>{t('actions-label')}</strong>
      </p>
      <ul className="cases-list">
        <li>{t('action-1')}</li>
        <li>{t('action-2')}</li>
        <li>{t('action-3')}</li>
        <li>{t('action-4')}</li>
      </ul>
    </div>

    <div className="case-card">
      <h3 className="case-subtitle">{t('waterSanitation')}</h3>
      <p>
        <strong>{t('goal-label')}:</strong> {t('water-sanitation-goal')}
      </p>
      <p className="actions-header">
        <strong>{t('actions-label')}</strong>
      </p>
      <ul className="cases-list">
        <li>{t('water-action-1')}</li>
        <li>{t('water-action-2')}</li>
        <li>{t('water-action-3')}</li>
      </ul>
    </div>

    <div className="case-card">
      <h3 className="case-subtitle">{t('constructionInfrastructure')}</h3>
      <p>
        <strong>{t('goal-label')}:</strong> {t('construction-goal')}
      </p>
      <p className="actions-header">
        <strong>{t('actions-label')}</strong>
      </p>
      <ul className="cases-list">
        <li>{t('construction-action-1')}</li>
        <li>{t('construction-action-2')}</li>
        <li>{t('construction-action-3')}</li>
        <li>{t('construction-action-4')}</li>
      </ul>
    </div>

    <div className="case-card">
      <h3 className="case-subtitle">{t('localProductionIndustry')}</h3>
      <p>
        <strong>{t('goal-label')}:</strong> {t('production-industry-goal')}
      </p>
      <p className="actions-header">
        <strong>{t('actions-label')}</strong>
      </p>
      <ul className="cases-list">
        <li>{t('production-action-1')}</li>
        <li>{t('production-action-2')}</li>
        <li>{t('production-action-3')}</li>
      </ul>
    </div>

    <div className="case-card">
      <h3 className="case-subtitle">{t('mobilityTransportation')}</h3>
      <p>
        <strong>{t('goal-label')}:</strong> {t('mobility-goal')}
      </p>
      <p className="actions-header">
        <strong>{t('actions-label')}</strong>
      </p>
      <ul className="cases-list">
        <li>{t('mobility-action-1')}</li>
        <li>{t('mobility-action-2')}</li>
        <li>{t('mobility-action-3')}</li>
        <li>{t('mobility-action-4')}</li>
        <li>{t('mobility-action-5')}</li>
      </ul>
    </div>

   
    <div className="case-card">
      <h3 className="case-subtitle">{t('agricultureFood')}</h3>
      <p>
        <strong>{t('goal-label')}:</strong> {t('agriculture-food-goal')}
      </p>
      <p className="actions-header">
        <strong>{t('actions-label')}</strong>
      </p>
      <ul className="cases-list">
        <li>{t('agriculture-action-1')}</li>
        <li>{t('agriculture-action-2')}</li>
        <li>{t('agriculture-action-3')}</li>
      </ul>
    </div>

    <div className="case-card">
      <h3 className="case-subtitle">{t('energy')}</h3>
      <p>
        <strong>{t('goal-label')}:</strong> {t('energy-goal')}
      </p>
      <p className="actions-header">
        <strong>{t('actions-label')}</strong>
      </p>
      <ul className="cases-list">
        <li>{t('energy-action-1')}</li>
        <li>{t('energy-action-2')}</li>
        <li>{t('energy-action-3')}</li>
      </ul>
    </div>

<div>
<br></br>
   <p className="actions-header">{t('goal-partedolink-1')}</p>
    <p className="actions-header">{t('goal-partedolink-2')}</p>
    <a href="https://circularcitiesdeclaration.eu/about/ccd-report?utm_source=chatgpt.com"><p className="actions-header">{t('goal-partedolink-link')}</p></a>
    <p className="actions-header">{t('goal-partedolink-3')}</p>


</div>

  </div>
</div>
  );
}

export default Tool;